






























import { UiIcon, UiRippleInk } from './keen-ui';

export default {
  name: 'epb-tabs',
  components: {
    UiRippleInk,
    UiIcon
  },
  props: {
    tabs: Array, // { id: string, text?: string, icon?: string, color?: ColorEnum, disabled?: boolean, closable?: boolean}[]
    selectedTabId: {
      type: String,
      required: true
    },
    fullWidth: Boolean
  },
  methods: {
    getTabClasses: function (tab: any): string[] {
      const tabClasses = [];
      if (tab.disabled) {
        tabClasses.push('epb-tabs__tab--disabled');
      }
      if (tab.closable) {
        tabClasses.push('epb-tabs__tab--closable');
      }
      if (this.selectedTabId === tab.id) {
        tabClasses.push('epb-tabs__tab--selected');
      }
      if (!!tab.color) {
        tabClasses.push(`epb-tabs__tab--${ tab.color }`);
      }
      return tabClasses;
    },
    onTabClick: function (tabId: string): void {
      if (tabId !== this.selectedTabId) {
        this.updateSelectedTabId(tabId);
      }
    },
    updateSelectedTabId: function (tabId: string): void {
      this.$emit('update:selectedTabId', tabId);
      this.$emit('updateSelectedTabId', tabId);
    }
  },
  watch: {
    selectedTabId: {
      handler: function (): void {
        if (!this.tabs.find(tabConfig => (tabConfig.id === this.selectedTabId && !tabConfig.disabled))) {
          const firstTabEnabled = this.tabs.find(tabConfig => !tabConfig.disabled);
          this.updateSelectedTabId((!!firstTabEnabled ? firstTabEnabled.id : ''));
        }
      },
      immediate: true
    }
  }
};
